// extracted by mini-css-extract-plugin
export default {"bghome":"Home_bghome__c-MJa","head1":"Home_head1__JkM0Z","head2":"Home_head2__jFO1N"};